import sStorage from '@/views/s-storage/s-storage.vue';
import Dashboard from '@/views/dashboard/dashboard.vue';

import inBound from '@/views/in-bound/in-bound.vue';
import listOfClients from '@/views/list-of-clients/list-of-clients.vue';
import inStock from '@/views/in-stock/in-stock.vue';
import inProcess from '@/views/in-process/in-process.vue';
import readyForShipment from '@/views/ready-for-shipment/ready-for-shipment.vue';
import processing from '@/views/processing/processing.vue';
import shipped from '@/views/shipped/shipped.vue';
import utilized from '@/views/utilized/utilized.vue';
import prFbaShipment from '@/views/processing-fba-shipment/processing-fba-shipment.vue';
import prFbmShipment from '@/views/processing-fbm-shipment/processing-fbm-shipment.vue';
import shFbaShipment from '@/views/shipped-fba-shipment/shipped-fba-shipment.vue';
import shFbmShipment from '@/views/shipped-fbm-shipment/shipped-fbm-shipment.vue';
import readyForUtilize from '@/views/ready-for-utilize/ready-for-utilize.vue';

const routes = [
  {
    path: '/billing',
    component: Dashboard,
    children: [
      {
        name: 'billing',
        path: '',
        component: () => import('@/views/billing/billing.vue'),
        children: [
          {
            name: 'billing.valuating',
            path: 'valuating',
            component: () => import('@/views/billing/list-for-valuation/list-for-valuation.vue'),
          }
        ],
      }
    ],
  },
  {
    path: '/',
    redirect: '/storage',
    component: Dashboard,
    children: [
      {
        path: '/storage',
        name: 'storage',
        redirect: '/storage/in-bound',
        component: sStorage,
        children: [
          {
            path: 'clients',
            name: 'storage-clients',
            component: listOfClients,
          },
          {
            path: 'in-bound',
            name: 'storage-in-bound',
            component: inBound,
          },
          {
            path: 'in-stock',
            name: 'storage-in-stock',
            component: inStock,
          },
          {
            path: 'in-process',
            name: 'storage-in-process',
            component: inProcess,
          },
          {
            path: 'ready-for-shipment',
            name: 'storage-ready-for-shipment',
            component: readyForShipment,
          },
          {
            path: 'processing',
            component: processing,
            name: 'storage-processing',
            redirect: '/storage/processing/fba-shipment',
            children: [
              {
                path: 'fba-shipment',
                name: 'storage-processing-fba-shipment',
                component: prFbaShipment,
              },
              {
                path: 'fbm-shipment',
                name: 'storage-processing-fbm-shipment',
                component: prFbmShipment,
              },
            ],
          },
          {
            path: 'shipped',
            component: shipped,
            name: 'storage-shipped',
            redirect: '/storage/shipped/fba-shipment',
            children: [
              {
                path: 'fba-shipment',
                name: 'storage-shipped-fba-shipment',
                component: shFbaShipment,
              },
              {
                path: 'fbm-shipment',
                name: 'storage-shipped-fbm-shipment',
                component: shFbmShipment,
              },
            ],
          },
          {
            path: 'ready-for-utilize',
            name: 'storage-ready-for-utilize',
            component: readyForUtilize,
          },
          {
            path: 'utilized',
            name: 'storage-utilized',
            component: utilized,
          },
        ],
      },
    ],
  },
];

export default routes.map((route) => ({...route, meta: {public: false}}));
